// extracted by mini-css-extract-plugin
export default {"contact":"contact_contact__g9Cd4","main":"contact_main__JpyNK","title":"contact_title__djPpB","ignoreConvert":"contact_ignoreConvert__WYg6H","rotate":"contact_rotate__Y+3SM"};